import React, { PureComponent } from 'react';
import { themr } from 'react-css-themr';
import _ from 'lodash';
import { ButtonWithPopover, ButtonTypes } from 'common/components/core/button';
import { Select, SelectTypes } from 'common/components/core/select';
import defaultTheme from './DayWeekSelector.scss';
import classnames from 'classnames';
import { DayOfWeekType } from 'common/enums/DateTimeEnums';

class DayWeekSelector extends PureComponent {
    static defaultProps = {
        multiSelectDays: true
    };
    onChange = value => {
        const { onChange, chosenDays } = this.props;
        onChange &&
            onChange({
                weeks: value,
                days: chosenDays
            });
    };
    renderWeeks() {
        const {
            theme,
            weekTitle,
            isEditing,
            disabled,
            weekList,
            chosenWeeks,
            required,
            placeholder,
            onBlur,
            t,
            ...others
        } = this.props;
        return (
            <div className={theme.right}>
                {weekTitle ? (
                    <div className={theme.title}>{weekTitle}</div>
                ) : null}
                <Select
                    maxMenuHeight={190}
                    theme={theme}
                    noMarginBottom
                    disabled={isEditing && disabled}
                    selectType={SelectTypes.Outline}
                    options={weekList}
                    openMenuOnFocus
                    blurInputOnSelect={false}
                    isSearchable={false}
                    isClearable={!required}
                    placeholder={t(placeholder)}
                    value={chosenWeeks}
                    onChange={this.onChange}
                    onBlur={onBlur}
                    {...others}
                />
            </div>
        );
    }
    onClick = newValue => {
        const {
            onChange,
            chosenDays,
            chosenWeeks,
            multiSelectDays
        } = this.props;
        let newChosenDays = [];
        if (multiSelectDays) {
            const index = chosenDays.indexOf(newValue);
            if (index === -1) {
                newChosenDays = [...chosenDays, newValue];
            } else {
                newChosenDays = [
                    ...chosenDays.slice(0, index),
                    ...chosenDays.slice(index + 1, chosenDays.length)
                ];
            }
        } else {
            if (chosenDays && newValue === chosenDays[0]) {
                newChosenDays = [];
            } else {
                newChosenDays = [newValue];
            }
        }
        onChange &&
            onChange({
                weeks: chosenWeeks,
                days: newChosenDays
            });
    };
    renderDays() {
        const { dayTitle, chosenDays, theme, t, ...others } = this.props;
        return (
            <div className={theme.left}>
                {dayTitle ? (
                    <div className={theme.dayTitle}>{dayTitle}</div>
                ) : null}
                <div className={theme.daysWrap}>
                    {_.map(DayOfWeekType, label => {
                        const clicked = chosenDays.indexOf(label) > -1;
                        return (
                            <ButtonWithPopover
                                {...others}
                                circle
                                ripple={false}
                                buttonType={ButtonTypes.Text}
                                label={t(`daysShortCode.${label}`)}
                                fieldId={label}
                                key={label}
                                theme={theme}
                                className={classnames(theme.button, {
                                    [theme.clicked]: clicked
                                })}
                                onClick={this.onClick}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
    render() {
        const { weekList, theme } = this.props;
        return (
            <div className={theme.dayWeekSelector}>
                {this.renderDays()}
                {weekList ? this.renderWeeks() : null}
            </div>
        );
    }
}

export default themr('DayWeekSelector', defaultTheme)(DayWeekSelector);
